import { motion, useReducedMotion } from "framer-motion";

/** Fade-up sutil al entrar en viewport, reusado por todas las secciones de
 * la landing. Solo anima una vez (no re-triggerea al volver a scrollear).
 * Fix D (2026-09-09): transicion mas suave/progresiva (0.9s, easing del
 * hero, umbral de disparo mas temprano) + respeta prefers-reduced-motion. */
export default function ScrollReveal({ children, delay = 0, className = "", y = 24, as = "div" }) {
  const Component = motion[as] || motion.div;
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return <div className={className}>{children}</div>;
  }
  return (
    <Component
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </Component>
  );
}
